// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__mI76_","alert":"SettungsInbox_alert__3I9vu"};